/* @generated */

// ../src/tabs/tabs.tsx
import classNames4 from "classnames";
import "focus-visible";
import * as React12 from "react";

// ../src/tabs/context.tsx
import * as React from "react";
var NONE_SELECTED = "";
var defaultValue = {
  // When consumed by `Tabs`, this is set to `Tabs.props.selectedTab`, however it needs to be
  // set to none selected initially
  selectedTab: NONE_SELECTED,
  addTab: () => false,
  removeTab: () => false,
  selectTab: () => false,
  moveFocus: () => false,
  focusTab: () => false,
  updateSelector: () => false,
  selectorProps: {
    selectorOffset: 0,
    selectorWidth: 0,
    shouldAnimate: true
  },
  setOverflowTrigger: () => {
  },
  isMenuOpen: false,
  setIsMenuOpen: () => {
  },
  visibilityMap: /* @__PURE__ */ new Map(),
  setVisibilityMap: () => {
  },
  isFocusVisibleForTab: () => false
};
var TabContext = React.createContext(defaultValue);

// ../src/tabs/group.tsx
import classNames from "classnames";
import * as React6 from "react";

// ../src/tabs/selector.tsx
import cx from "classnames";
import * as React2 from "react";

// ../src/tabs/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var group = _7a468({ defaultClassName: "dig-14v7e7l3_21-7-0", variantClassNames: { variant: { justified: "dig-14v7e7l4_21-7-0", responsive: "dig-14v7e7l5_21-7-0", legacy: "dig-14v7e7l6_21-7-0" }, hasDivider: { true: "dig-14v7e7l7_21-7-0" }, hasHorizontalPadding: { true: "dig-14v7e7l8_21-7-0" } }, defaultVariants: { variant: "legacy", hasDivider: true, hasHorizontalPadding: true }, compoundVariants: [] });
var overflow = "dig-14v7e7ld_21-7-0";
var overflowChild = _7a468({ defaultClassName: "dig-14v7e7lf_21-7-0", variantClassNames: { isInvisible: { true: "dig-14v7e7lg_21-7-0", false: "dig-14v7e7lh_21-7-0" } }, defaultVariants: { isInvisible: false }, compoundVariants: [] });
var overflowContent = "dig-14v7e7le_21-7-0";
var overflowContentShadow = "dig-14v7e7li_21-7-0";
var overflowElements = "dig-14v7e7lj_21-7-0";
var overflowMenuContentItemUnselected = "dig-14v7e7lk_21-7-0";
var overflowTrigger = _7a468({ defaultClassName: "dig-14v7e7ll_21-7-0", variantClassNames: { active: { true: "dig-14v7e7lm_21-7-0", false: "dig-14v7e7ln_21-7-0" } }, defaultVariants: { active: false }, compoundVariants: [] });
var overflowTriggerButton = "dig-14v7e7lo_21-7-0";
var overflowTriggerButtonAriaLabel = "dig-14v7e7lp_21-7-0";
var panel = _7a468({ defaultClassName: "dig-14v7e7la_21-7-0", variantClassNames: { isSelected: { true: "dig-14v7e7lb_21-7-0", false: "dig-14v7e7lc_21-7-0" } }, defaultVariants: { isSelected: false }, compoundVariants: [] });
var selector = _7a468({ defaultClassName: "dig-14v7e7l1_21-7-0", variantClassNames: { shouldAnimate: { true: "dig-14v7e7l2_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tab = "dig-14v7e7l9_21-7-0";
var tabs = "dig-14v7e7l0_21-7-0";

// ../src/tabs/selector.tsx
var Selector = ({ style }) => {
  const [hasInitialValueChanged, setHasInitialValueChanged] = React2.useState(false);
  const { selectorProps } = React2.useContext(TabContext);
  const { selectorOffset, selectorWidth, shouldAnimate } = selectorProps;
  const styl = {
    ...style,
    width: selectorWidth,
    transform: `translate(${selectorOffset}px)`
  };
  if (selectorProps.selectorColor) {
    styl.backgroundColor = selectorProps.selectorColor;
  }
  React2.useEffect(() => {
    if (selectorProps.selectorWidth !== 0 && !hasInitialValueChanged) {
      setHasInitialValueChanged(true);
    }
  }, [hasInitialValueChanged, selectorProps]);
  return /* @__PURE__ */ React2.createElement(
    "span",
    {
      "data-testid": "digTabsSelector",
      className: cx(
        "dig-Tabs-selector",
        selector({
          shouldAnimate
        }),
        {
          "dig-Tabs-selector--shouldAnimate": hasInitialValueChanged && shouldAnimate
        }
      ),
      style: styl
    }
  );
};

// ../src/tabs/overflow.tsx
import * as React4 from "react";
import cls from "classnames";
import { Menu as Menu2 } from "@dropbox/dig-components/menu";

// ../src/_global/constants.ts
var TAB_KEY = "Tab";
var UP_ARROW_KEY = "ArrowUp";
var DOWN_ARROW_KEY = "ArrowDown";
var LEFT_ARROW_KEY = "ArrowLeft";
var RIGHT_ARROW_KEY = "ArrowRight";
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = `[${buttonDataAttributeName}]`;
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = `[${buttonContentDataAttributeName}]`;
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = `[${splitButtonDataAttributeName}]`;
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = `[${iconButtonDataAttributeName}]`;

// ../src/tabs/overflow.tsx
import { ClickOutside } from "@dropbox/dig-components/click_outside";

// ../src/tabs/overflow_tab_item.tsx
import cx2 from "classnames";
import * as React3 from "react";
import { Menu } from "@dropbox/dig-components/menu";
var OverflowTabItem = ({
  children,
  className,
  id,
  withAccessory,
  onMouseUp,
  onFocus,
  ...rest
}) => {
  const { selectTab, selectedTab, isFocusVisibleForTab } = React3.useContext(TabContext);
  const isSelected = selectedTab === id;
  const _onFocus = (e) => {
    selectTab(id);
    if (onFocus) {
      onFocus(e);
    }
  };
  const _onMouseUp = (e) => {
    selectTab(id, false);
    if (onMouseUp) {
      onMouseUp(e);
    }
  };
  const _classNames = cx2(className, {
    "dig-Tabs-overflow-item--unselected": !isSelected,
    [overflowMenuContentItemUnselected]: !isSelected
  });
  return (
    // Forcing this to appear as if it were a Tab based on Benevity's implementation
    // @see https://skyline.benevity.org/components/layout/text-tabs/#responsive
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /* @__PURE__ */ React3.createElement(
      Menu.SelectItem,
      {
        ...rest,
        value: id,
        role: "menuitem",
        "aria-selected": isSelected,
        "aria-controls": `${id}-panel`,
        selected: isSelected,
        className: _classNames,
        onFocus: _onFocus,
        onMouseUp: _onMouseUp,
        withRightAccessory: withAccessory,
        _pseudoClass: isFocusVisibleForTab(id) ? "focus" : void 0
      },
      children
    )
  );
};
OverflowTabItem.displayName = "Tabs.OverflowTabItem";

// ../src/tabs/overflow-shadow-consts.ts
var TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX = "digTabsOverflowShadow-";

// ../src/tabs/overflow.tsx
import { useMountEffect } from "@react-hookz/web";
var Overflow = ({
  children,
  withOverflowTrigger,
  className,
  ...rest
}) => {
  const shadowRef = React4.useRef(null);
  const observer = React4.useRef();
  const { visibilityMap, setVisibilityMap, isMenuOpen, setIsMenuOpen, moveFocus } = React4.useContext(TabContext);
  const hasOverflowMenu = !visibilityMap || !Array.from(visibilityMap.values()).every((item) => item === true);
  const [hasIntersectionObserver, setHasIntersectionObserver] = React4.useState(
    void 0
  );
  const [prevChildren, setPrevChildren] = React4.useState(null);
  useMountEffect(() => {
    if (typeof window !== "undefined" && window.IntersectionObserver) {
      setHasIntersectionObserver(true);
    } else {
      setHasIntersectionObserver(false);
    }
  });
  const handleKeyDown = (event) => {
    switch (event.key) {
      case DOWN_ARROW_KEY:
      case RIGHT_ARROW_KEY:
        moveFocus(1);
        event.preventDefault();
        break;
      case LEFT_ARROW_KEY:
      case UP_ARROW_KEY:
        moveFocus(-1);
        event.preventDefault();
        break;
    }
  };
  const handleClickOutside = () => {
    setIsMenuOpen(false);
  };
  React4.useEffect(() => {
    const isChildrenChanged = () => {
      let idsOfPrevChildren = "", idsOfChildren = "";
      React4.Children.map(prevChildren, (child) => {
        if (React4.isValidElement(child)) {
          idsOfPrevChildren += child.props.id;
        }
      });
      React4.Children.map(children, (child) => {
        if (React4.isValidElement(child)) {
          idsOfChildren += child.props.id;
        }
      });
      return idsOfPrevChildren !== idsOfChildren;
    };
    if (hasIntersectionObserver === void 0) {
      return;
    }
    if (!isChildrenChanged()) {
      return;
    } else {
      setPrevChildren(children);
    }
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id.replace(TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX, "");
        setVisibilityMap((prev) => {
          const newMap = new Map(prev);
          newMap.set(id, entry.isIntersecting);
          return newMap;
        });
      });
    };
    if (hasIntersectionObserver) {
      if (shadowRef.current) {
        if (observer.current) {
          observer.current.disconnect();
        }
        observer.current = new IntersectionObserver(handleIntersection, {
          root: shadowRef.current,
          threshold: 1
        });
        Array.from(shadowRef.current.children).forEach((child) => {
          if (observer.current) observer.current.observe(child);
        });
      }
    } else {
      if (shadowRef.current) {
        const map = /* @__PURE__ */ new Map();
        Array.from(shadowRef.current.children).forEach((child) => {
          map.set(child.id, true);
        });
        setVisibilityMap(map);
      }
    }
  }, [setVisibilityMap, hasIntersectionObserver, children, prevChildren]);
  React4.useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);
  return /* @__PURE__ */ React4.createElement("div", { className: cls("dig-Tabs-overflow", overflow) }, /* @__PURE__ */ React4.createElement("div", { className: cls("dig-Tabs-overflow-content", overflowContent) }, /* @__PURE__ */ React4.createElement(
    "ul",
    {
      className: cls("dig-Tabs-overflow-elements", overflowElements, className),
      role: "tablist",
      ...rest
    },
    React4.Children.map(children, (child) => {
      if (React4.isValidElement(child)) {
        {
        }
        const isVisible = visibilityMap.get(child.props.id);
        return React4.cloneElement(child, {
          className: cls(
            child.props.className,
            "dig-Tabs-overflow-child",
            overflowChild({ isInvisible: !isVisible }),
            {
              "dig-Tabs-overflow-child-invisible": !isVisible
            }
          ),
          key: child.props.id
        });
      }
    })
  ), hasOverflowMenu && /* @__PURE__ */ React4.createElement(
    Menu2.Wrapper,
    {
      className: "dig-Tabs-overflow-menu",
      onToggle: ({ isOpen }) => {
        setIsMenuOpen(isOpen);
      },
      onKeyDown: handleKeyDown
    },
    ({ triggerRef }) => /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(
      ClickOutside,
      {
        isClickThroughPortaled: true,
        isActive: isMenuOpen,
        onClickOutside: handleClickOutside
      },
      withOverflowTrigger({ ref: triggerRef }),
      /* @__PURE__ */ React4.createElement(
        Menu2.Content,
        {
          triggerRef,
          open: isMenuOpen,
          positioningStrategy: "fixed",
          className: cls("dig-Tabs-overflow-menu-content")
        },
        /* @__PURE__ */ React4.createElement(Menu2.Segment, null, React4.Children.map(children, (child) => {
          if (React4.isValidElement(child)) {
            if (!visibilityMap.get(child.props.id)) {
              return /* @__PURE__ */ React4.createElement(OverflowTabItem, { key: child.props.id, ...child.props });
            }
          }
        }))
      )
    ))
  )), hasIntersectionObserver && /* @__PURE__ */ React4.createElement(
    "div",
    {
      className: cls(
        "dig-Tabs-overflow-content",
        "dig-Tabs-overflow-content-shadow",
        overflowContent,
        overflowContentShadow
      ),
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React4.createElement(
      "div",
      {
        className: cls("dig-Tabs-overflow-elements", overflowElements),
        ref: shadowRef
      },
      React4.Children.map(children, (child) => {
        if (React4.isValidElement(child)) {
          return React4.cloneElement(child, {
            id: `${TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX}${child.props.id}`,
            className: cls(
              child.props.className,
              "dig-Tabs-overflow-child",
              overflowChild()
            ),
            "aria-hidden": true,
            tabIndex: -1,
            // Update the testid so unit tests ignore the overflow/shadow child
            "data-testid": "data-testid" in child.props ? `${TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX}${child.props["data-testid"]}` : void 0
          });
        }
      })
    ),
    hasOverflowMenu && withOverflowTrigger({
      isShadow: true
    })
  ));
};
Overflow.displayName = "Overflow";

// ../src/tabs/overflow_trigger.tsx
import cx3 from "classnames";
import * as React5 from "react";
import { MoreHorizontalLine } from "@dropbox/dig-icons/assets";
import { IconButton } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
var OverflowTrigger = React5.forwardRef(
  ({ id, className, isShadow, onKeyDown, onClick, renderLabel = () => "", ...rest }, ref) => {
    const triggerRef = React5.useRef(null);
    const { selectedTab, visibilityMap, setOverflowTrigger, moveFocus, setIsMenuOpen } = React5.useContext(TabContext);
    const active = !visibilityMap.get(selectedTab);
    const cls2 = cx3(
      "dig-Tabs-overflow-trigger",
      overflowTrigger({
        active
      }),
      {
        "dig-Tabs-overflow-trigger--active": active
      },
      className
    );
    React5.useEffect(() => {
      if (!id || id.indexOf(TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX) === -1 && triggerRef.current) {
        setOverflowTrigger(triggerRef.current);
      }
    }, [ref, setOverflowTrigger, id]);
    const handleOnClick = (event) => {
      setIsMenuOpen((prev) => !prev);
      if (onClick) {
        onClick(event);
      }
    };
    const handleKeyDown = (event) => {
      switch (event.key) {
        case LEFT_ARROW_KEY:
          moveFocus(-1);
          event.preventDefault();
          break;
        case RIGHT_ARROW_KEY:
          moveFocus(1);
          event.preventDefault();
          break;
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    };
    React5.useImperativeHandle(
      ref,
      () => {
        return {
          current: triggerRef.current,
          getBoundingClientRect: () => {
            if (!triggerRef.current) return;
            return triggerRef.current.getBoundingClientRect();
          },
          focus: () => {
            if (!triggerRef.current) return;
            return triggerRef.current.focus();
          }
        };
      },
      [triggerRef]
    );
    const visibles = [];
    const hiddens = [];
    for (const [tabId, isVisible] of Array.from(visibilityMap.entries())) {
      if (isVisible) {
        visibles.push(tabId);
      } else {
        hiddens.push(tabId);
      }
    }
    return /* @__PURE__ */ React5.createElement("div", { className: cls2 }, /* @__PURE__ */ React5.createElement(
      IconButton,
      {
        className: cx3("dig-Tabs-overflow-trigger-button", overflowTriggerButton),
        size: "medium",
        ref: triggerRef,
        id: isShadow ? `${TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX}-overflowTrigger` : id,
        "data-testid": isShadow ? `${TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX}-overflowTrigger` : "digTabsOverflowTrigger",
        tabIndex: -1,
        variant: "borderless",
        onKeyDown: handleKeyDown,
        onClick: handleOnClick,
        ...rest
      },
      /* @__PURE__ */ React5.createElement(UIIcon, { size: "small", src: MoreHorizontalLine }),
      /* @__PURE__ */ React5.createElement(
        "span",
        {
          className: cx3(
            "dig-Tabs-overflow-trigger-button-aria-label",
            overflowTriggerButtonAriaLabel
          )
        },
        renderLabel(hiddens, visibles)
      )
    ));
  }
);

// ../src/tabs/group.tsx
import { useResizeObserver } from "@react-hookz/web";

// ../src/_global/resize_observer_polyfill.ts
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
var polyfillResizeObserverGlobally = () => {
  if ("ResizeObserver" in globalThis === false) {
    globalThis.ResizeObserver = ResizeObserverPolyfill;
  }
};

// ../src/tabs/group.tsx
polyfillResizeObserverGlobally();
var Group = ({
  children,
  variant = "legacy",
  className,
  justified: _justified,
  containerClassName,
  hasDivider = true,
  hasHorizontalPadding = true,
  overflowTriggerProps = {},
  ...rest
}) => {
  const isJustified = variant === "justified";
  const isResponsive = variant === "responsive";
  const cls2 = classNames(
    "dig-Tabs-group",
    group({ variant, hasDivider, hasHorizontalPadding: hasHorizontalPadding && !isJustified }),
    !isResponsive ? className : "",
    {
      "dig-Tabs-group--justified": isJustified,
      "dig-Tabs-group--hasDivider": hasDivider,
      "dig-Tabs-group--hasHorizontalPadding": hasHorizontalPadding && !isJustified
    }
  );
  const { updateSelector } = React6.useContext(TabContext);
  const containerRef = React6.useRef(null);
  useResizeObserver(containerRef, (entry) => {
    if (!entry) {
      return;
    }
    updateSelector(false);
  });
  const TagName = isResponsive ? "div" : "ul";
  const wrapperAttributes = isResponsive ? {} : { ...rest };
  const overflowAttributes = isResponsive ? { className, ...rest } : {};
  return /* @__PURE__ */ React6.createElement("div", { className: containerClassName, ref: containerRef }, /* @__PURE__ */ React6.createElement(Selector, null), /* @__PURE__ */ React6.createElement(TagName, { className: cls2, role: !isResponsive ? "tablist" : void 0, ...wrapperAttributes }, isResponsive ? /* @__PURE__ */ React6.createElement(
    Overflow,
    {
      withOverflowTrigger: (props) => /* @__PURE__ */ React6.createElement(OverflowTrigger, { ...overflowTriggerProps, ...props }),
      ...overflowAttributes
    },
    children
  ) : children));
};
Group.displayName = "Tabs.Group";

// ../src/tabs/panel.tsx
import classNames2 from "classnames";
import * as React7 from "react";
var Panel = ({
  children,
  className,
  tabId,
  isCostly = false,
  style,
  onKeyDown,
  ...rest
}) => {
  const wasViewed = React7.useRef(false);
  const { selectedTab, focusTab } = React7.useContext(TabContext);
  const isSelected = tabId === selectedTab;
  const cls2 = classNames2(
    "dig-Tabs-panel",
    panel({
      isSelected
    }),
    {
      "dig-Tabs-panel--isSelected": isSelected
    },
    className
  );
  React7.useEffect(() => {
    if (!wasViewed.current && isSelected) {
      wasViewed.current = true;
    }
  }, [wasViewed, isSelected]);
  if (!isSelected && !isCostly) return null;
  if (!isSelected && !wasViewed.current) return null;
  const handleKeyDown = (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key === UP_ARROW_KEY) {
      focusTab(tabId);
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const styl = isSelected ? style : { ...style, display: "none" };
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ React7.createElement(
      "div",
      {
        className: cls2,
        style: styl,
        id: `${tabId}-panel`,
        role: "tabpanel",
        "aria-hidden": !isSelected,
        "aria-labelledby": tabId,
        onKeyDown: handleKeyDown,
        ...rest
      },
      children
    )
  );
};
Panel.displayName = "Tabs.Panel";

// ../src/tabs/tab.tsx
import classNames3 from "classnames";
import * as React9 from "react";
import { Split } from "@dropbox/dig-foundations";

// ../src/_global/components/internal_box.tsx
import * as React8 from "react";
import { Box } from "@dropbox/dig-foundations";
var InternalBox = ({
  children,
  className: _cls,
  _dangerouslySetClassName,
  sx,
  ...rest
}) => {
  return (
    // For now we pass through `sx` as it doesn't exist on `Box` yet, but an optimization to this will come soon, which will add this prop...
    /* @__PURE__ */ React8.createElement(Box, { ...sx, ...rest, className: _dangerouslySetClassName }, children)
  );
};

// ../src/tabs/tab.tsx
var Tab = ({
  children,
  className,
  id,
  withAccessory,
  onClick,
  onKeyDown,
  ...rest
}) => {
  const cls2 = classNames3("dig-Tabs-tab", tab, className);
  const { selectedTab, addTab, removeTab, selectTab, moveFocus, setIsMenuOpen } = React9.useContext(TabContext);
  const tabElement = React9.useRef(null);
  React9.useEffect(() => {
    if (tabElement.current && id && id.indexOf(TABS_OVERFLOW_SHADOW_ELEMENT_ID_PREFIX) === -1) {
      addTab(id, tabElement.current);
      return () => {
        removeTab(id);
      };
    }
  }, [addTab, removeTab, tabElement, id]);
  const isActive = id === selectedTab;
  const handleClick = (event) => {
    if (!isActive && ("buttons" in event && event.buttons === 0 || !("buttons" in event))) {
      selectTab(id, false);
      if (onClick) {
        onClick(event);
      }
    }
  };
  const handleKeyDown = (event) => {
    switch (event.key) {
      case DOWN_ARROW_KEY:
      case RIGHT_ARROW_KEY:
        moveFocus(1);
        event.preventDefault();
        break;
      case LEFT_ARROW_KEY:
      case UP_ARROW_KEY:
        moveFocus(-1);
        event.preventDefault();
        break;
      // Close the menu since focus is moved away from some internal child
      case TAB_KEY:
        setIsMenuOpen(false);
        break;
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  return /* @__PURE__ */ React9.createElement(
    "li",
    {
      ...rest,
      ref: tabElement,
      id,
      role: "tab",
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      className: cls2,
      tabIndex: isActive ? 0 : -1,
      "aria-selected": isActive,
      "aria-controls": `${id}-panel`
    },
    /* @__PURE__ */ React9.createElement(Split, { gap: "Micro Small", alignX: "center", alignY: "center" }, /* @__PURE__ */ React9.createElement(React9.Fragment, null, withAccessory && // Force a flex display mode to force all children to be block
    // Flex Items https://www.w3.org/TR/css-flexbox-1/#flex-items
    // Blockification https://www.w3.org/TR/css-display-3/#transformations
    /* @__PURE__ */ React9.createElement(Split.Item, null, /* @__PURE__ */ React9.createElement(InternalBox, { sx: { display: "flex" } }, withAccessory)), children && /* @__PURE__ */ React9.createElement(Split.Item, null, children)))
  );
};
Tab.displayName = "Tabs.Tab";

// ../src/tabs/useTabs.ts
import * as React10 from "react";
var useTabs = ({ selectedTab, onSelection }) => {
  const [tabEls, setTabEls] = React10.useState({});
  const [selectorWidth, setSelectorWidth] = React10.useState(0);
  const [selectorOffset, setSelectorOffset] = React10.useState(0);
  const [shouldAnimateSelector, setShouldAnimateSelector] = React10.useState(true);
  const [overflowTrigger2, setOverflowTrigger] = React10.useState();
  const [isMenuOpen, setIsMenuOpen] = React10.useState(false);
  const [visibilityMap, setVisibilityMap] = React10.useState(/* @__PURE__ */ new Map());
  const isFocusVisibleForTab = React10.useCallback(
    (id) => {
      const tabElement = tabEls[id];
      if (!tabElement) {
        return false;
      }
      return tabElement.getAttribute("data-focus-visible-added") !== null;
    },
    [tabEls]
  );
  const addTab = React10.useCallback((id, tabElement) => {
    setTabEls((els) => ({ ...els, [id]: tabElement }));
  }, []);
  const removeTab = React10.useCallback((id) => {
    setTabEls((els) => {
      const newEls = { ...els };
      delete newEls[id];
      return newEls;
    });
  }, []);
  const focusTab = (id) => {
    const elem = tabEls[id];
    if (elem) {
      elem.focus();
    }
  };
  const selectTab = React10.useCallback(
    (value, wasKeyboardInteraction = true) => {
      if (wasKeyboardInteraction) {
        if (visibilityMap.get(value) && isMenuOpen) {
          setIsMenuOpen(false);
        }
        if (!visibilityMap.get(value) && !isMenuOpen) {
          setIsMenuOpen(true);
        }
      } else {
        if (isMenuOpen) {
          setIsMenuOpen(false);
        }
      }
      if (onSelection) {
        onSelection(value);
      }
      setShouldAnimateSelector(true);
    },
    [onSelection, visibilityMap, isMenuOpen]
  );
  const getNewIndex = (length, selectedIndex, offset) => {
    return offset === 1 ? selectedIndex + 1 >= length ? 0 : selectedIndex + 1 : selectedIndex - 1 < 0 ? length - 1 : selectedIndex - 1;
  };
  const moveFocus = (offset) => {
    let newIndex = 0;
    const keys = Object.keys(tabEls);
    if (keys.length > 1) {
      const selectedIndex = keys.findIndex((key) => key === selectedTab);
      newIndex = getNewIndex(keys.length, selectedIndex, offset);
      const newKey = keys[newIndex];
      selectTab(newKey);
      focusTab(newKey);
    }
  };
  const updateSelector = React10.useCallback(
    (shouldAnimate) => {
      const elem = tabEls[selectedTab];
      if (elem && (visibilityMap.get(selectedTab) || visibilityMap.size === 0)) {
        setSelectorWidth(elem.offsetWidth);
        setSelectorOffset(elem.offsetLeft);
      } else if (overflowTrigger2) {
        setSelectorWidth(0);
        setSelectorOffset(999);
      }
      if (typeof shouldAnimate !== "undefined") {
        setShouldAnimateSelector(shouldAnimate);
      }
    },
    [selectedTab, tabEls, overflowTrigger2, visibilityMap]
  );
  React10.useEffect(() => {
    updateSelector();
  });
  return {
    addTab,
    moveFocus,
    removeTab,
    selectorWidth,
    selectorOffset,
    shouldAnimateSelector,
    selectTab,
    focusTab,
    updateSelector,
    setOverflowTrigger,
    isMenuOpen,
    setIsMenuOpen,
    visibilityMap,
    setVisibilityMap,
    isFocusVisibleForTab
  };
};

// ../src/tabs/tabs.tsx
import { useTheme } from "@dropbox/dig-foundations";

// ../src/_global/useFontsReady.tsx
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import * as React11 from "react";
var useFontsReady = (callback, shouldRunOnFirstRun = false) => {
  const callbackRef = React11.useRef(callback);
  callbackRef.current = callback;
  useIsomorphicLayoutEffect(() => {
    let shouldStillRun = true;
    if (shouldRunOnFirstRun === false && "document" in globalThis && "fonts" in document) {
      document.fonts.ready.then(() => {
        if (shouldStillRun) {
          callbackRef.current();
        }
      });
    } else {
      callbackRef.current();
    }
    return () => {
      shouldStillRun = false;
    };
  }, []);
};

// ../src/tabs/tabs.tsx
var Tabs = ({
  children,
  className,
  inverse,
  onSelection,
  selectedTab,
  selectorColor,
  ...rest
}) => {
  const inverseClassName = useTheme().getInverseProps().className;
  const cls2 = classNames4("dig-Tabs-tabs", tabs, className, {
    [inverseClassName]: inverse
  });
  const {
    addTab,
    removeTab,
    selectorOffset,
    selectorWidth,
    shouldAnimateSelector,
    moveFocus,
    selectTab,
    focusTab,
    updateSelector,
    setOverflowTrigger,
    isMenuOpen,
    setIsMenuOpen,
    visibilityMap,
    setVisibilityMap,
    isFocusVisibleForTab
  } = useTabs({
    selectedTab,
    onSelection
  });
  const value = React12.useMemo(
    () => ({
      selectedTab,
      addTab,
      removeTab,
      moveFocus,
      selectTab,
      focusTab,
      updateSelector,
      selectorProps: {
        selectorOffset,
        selectorWidth,
        selectorColor,
        shouldAnimate: shouldAnimateSelector
      },
      setOverflowTrigger,
      isMenuOpen,
      setIsMenuOpen,
      visibilityMap,
      setVisibilityMap,
      isFocusVisibleForTab
    }),
    [
      selectedTab,
      addTab,
      removeTab,
      moveFocus,
      selectTab,
      focusTab,
      updateSelector,
      selectorOffset,
      selectorWidth,
      selectorColor,
      shouldAnimateSelector,
      setOverflowTrigger,
      isMenuOpen,
      setIsMenuOpen,
      visibilityMap,
      setVisibilityMap,
      isFocusVisibleForTab
    ]
  );
  useFontsReady(updateSelector);
  return /* @__PURE__ */ React12.createElement(TabContext.Provider, { value }, /* @__PURE__ */ React12.createElement("div", { className: cls2, "data-testid": "digTabsContainer", ...rest }, children));
};
Tabs.displayName = "Tabs";
Tabs.Panel = Panel;
Tabs.Tab = Tab;
Tabs.Group = Group;
export {
  Tabs
};
